import { Injectable } from "@angular/core";
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,
} from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { mergeMap, catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { finalize } from "rxjs/operators";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { ErrorService } from "../services/error/error.service";
/** Pass untouched request through to the next request handler. */
@Injectable()
export class DefaultInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private preloader: FuseProgressBarService,
        private errorService: ErrorService
    ) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        
        // if (localStorage.length == 0) {
        if (sessionStorage.length == 0) {
            this.preloader.open();
            if (
                req.url.includes("register") ||
                req.url.includes("login") ||
                req.url.includes("verifyUser") ||
                req.url.includes("forgotpassword") ||
                req.url.includes("verifyUse") ||
                req.url.includes("updatepassword") ||
                req.url.includes("getotp") ||
                req.url.includes("verifyOTPNew") ||
                req.url.includes("verifyUserNew")
            ) {
                return next.handle(req).pipe(
                    finalize(() => this.preloader.close()),
                    mergeMap((event: any) => {
                        return of(event);
                    }),
                    catchError((err: HttpErrorResponse) => {
                        return of(err);
                    })
                    // catchError((err: HttpErrorResponse) => {
                    //     return throwError(() => err);
                    // })
                );
            } else {
                this.router.navigateByUrl("/login");
            }
        } else {
            const userDetails = JSON.parse(localStorage.getItem("userDetails"));
            
            if (
                req.url.includes("heartbeat") ||
                req.url.includes("status") ||
                req.url.includes("betacmsassistant")
            ) {
                if (userDetails.token) {
                    const cloned = req.clone({
                        headers: req.headers.set(
                            "Authorization",
                            "Bearer " + userDetails.token
                        ),
                    });

                    // return next.handle(cloned);
                    return next.handle(cloned).pipe(
                        mergeMap((event: any) => {
                            if (!!event.body) {
                                if (event.body.message == "Token is not valid")
                                    this.router.navigateByUrl("/login");

                                return of(event);
                            } else {
                                return of(event);
                            }
                        }),
                        catchError((err: HttpErrorResponse) => {
                            return of(err);
                        })
                    );
                } else {
                    return next.handle(req);
                }
            }

            if (userDetails.token) {
                const cloned = req.clone({
                    headers: req.headers.set(
                        "Authorization",
                        "Bearer " + userDetails.token
                    ),
                });
                this.preloader.open();
                // return next.handle(cloned);
                return next.handle(cloned).pipe(
                    finalize(() => this.preloader.close()),
                    mergeMap((event: any) => {
                        if (!!event.body) {
                            if (event.body.message == "Token is not valid")
                                this.router.navigateByUrl("/login");
                            if (event.body.status == false) {
                                let params = {
                                    id: 66,

                                    username: userDetails.userName,
                                    email: userDetails.email,
                                    application_name: "cms",
                                    project_id: 1,
                                    application_plateform: "WEB",
                                    url: event.url,
                                    status: "Y",
                                    error_code: event.status,
                                    error_discription: event.body.message,
                                    created_by: userDetails.userId,
                                };
                                this.errorService.errorLog(params).subscribe(
                                    (resp: any) => {
                                        return of(event);
                                    },
                                    (err) => {}
                                );
                            }
                            return of(event);
                        } else {
                            return of(event);
                        }
                    }),
                    catchError((err: HttpErrorResponse) => {
                        return of(err);
                    })
                );
            } else {
                return next.handle(req);
            }
        }
    }

    handleError(error: HttpErrorResponse) {
        return throwError(error);
    }
}
